



































// Importing components
import LayoutMain from '@/layputs/LayoutMain.vue';
import TheCartItemList from '@/components/cart/TheCartItemList.vue';
import TheCartForm from '@/components/cart/TheCartForm.vue';
import BaseSection from '@/ui/BaseSection.vue';
// Importing function
import {getRestaurantPreview} from '@/ts/restaurants/get-restaurant';
import {getAddresses} from '@/ts/profile/addresses/get-addresses';
import {finishOrder} from '@/ts/orders/finish-order';
import {validateAddress} from '@/ts/profile/addresses/validate-address';
import {checkSession} from '@/ts/helpers';
import {handleScroll, submitCart} from '@/ts/other/additional';
import {getCart} from '@/ts/cart/get-cart';

export default {
    name: 'PageCartCheckout',
    components: {
        BaseSection,
        TheCartForm,
        TheCartItemList,
        LayoutMain,
    },
    props: {},
    data() {
        return {
            restaurant: {
                working_hours: Object(),
            },
            notes: String(),
            image: Object(),
            gift: String(),
            quantity: Array(),
            data: Object(),
            address: Object(),
            addresses: Array(),
            selected_address: String(),
            errors: Array(),
            donation: String(),
            promo: String(),
            auth: true,
        };
    },
    methods: {
        apply(coupon) {
            this.errors = [];
            getCart(this.$route.query.restaurant, coupon).then((response: any) => {
                this.data = response;
                // for (const item of this.data.data) {
                //     this.$set(this.quantity, item.id, item.attributes.quantity);
                // }
                // console.log(this.data);
                if (response.details.coupon.error !== null) {
                    this.errors.push(response.details.coupon.error);
                }
            });
        },
        submit() {
            // console.log(this.data.details);
            const body = {
                ...this.address,
                user_address: this.selected_address,
                gift: this.gift,
                total_price: this.data.details.final_price,
                notes: this.notes,
                donated_money: this.donation,
                coupon: this.promo,
            };
            this.errors = [];
            if (this.auth) { validateAddress(this.errors, body); }
            if (!this.auth && this.selected_address === '') {
                this.$swal.fire(
                    'Изберете адрес!',
                    '',
                    'error',
                );
                return;
            }
            if (this.errors.length === 0) {
                submitCart().then(() => {
                    finishOrder(body, this.$route.query.restaurant).then(() => {
                        if (!this.auth) {
                            this.$router.push({ name: 'orders' });
                        } else {
                            this.$router.push({ name: 'welcome' });
                        }
                    });
                });
            }
        },
    },
    mounted() {
        handleScroll();
    },
    destroyed() {
        window.removeEventListener('scroll', handleScroll);
    },
    created() {
        window.addEventListener('scroll', handleScroll);
        this.auth = !checkSession();
        // Initializing the data object
        this.address = {
            name: '', phone: '', address: '',
            town_ekatte: '', selected_province: '',
            selected_municipality: '',
        };
        getRestaurantPreview(this.$route.query.restaurant).then((response) => {
            this.restaurant =  response;
            this.restaurant.tags = this.restaurant.tags.slice(0, 3).join(', ');
            this.image = {'background-image': 'url(' + 'https://api.foodninja.net' + this.restaurant.cover_image + ')'};
            const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const date = new Date();
            const dayName = days[date.getDay()];
            this.restaurant.working_hours = this.restaurant.working_hours.find((item) => item.day === dayName);
        });
        getCart(this.$route.query.restaurant).then((response) => {
            this.data = response;
            for (const item of this.data.data) {
                this.$set(this.quantity, item.id, item.attributes.quantity);
            }
        });
        if (!this.auth) {
            getAddresses().then((response) => {
                this.addresses = response;
            });
        }
    },
};
